import { useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'
import styled from 'styled-components'

import {
  getAccountId,
  isAccountTypeRetailer,
  isLiteBrand,
} from 'store/currentUser/selectors'

import {
  DISCOVERY_DASHBOARD,
  LOOKBOOKS,
  PHOTO_GALLERY,
  PRESS,
  RETAILER_PROFILE,
  STOREFRONT,
} from 'routes/paths'

import { IProfileDropdownSelectors } from '../../navbarRevamp.types'
import DropdownMenuGroup from '../DropdownMenuGroup/DropdownMenuGroup'
import DropdownMenuTextLink from '../DropdownMenuTextLink/DropdownMenuTextLink'
import MenuLinkWrapper from '../MenuLinkWrapper/MenuLinkWrapper'
import NavbarDropdown from '../NavbarDropdown/NavbarDropdown'
import Trigger from '../Trigger/Trigger'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { ProfileDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'

const NavbarProfileDropdownContainer = styled.div`
  display: flex;
`

const NavbarProfileDropdown = () => {
  const { accountId, isRetailerAccount, isLiteBrandAccount } = useSelector<
    object,
    IProfileDropdownSelectors
  >((state) => ({
    accountId: getAccountId(state),
    isRetailerAccount: isAccountTypeRetailer(state),
    isLiteBrandAccount: isLiteBrand(state),
  }))
  if (isRetailerAccount) {
    const retailerProfileLink = generatePath(RETAILER_PROFILE, {
      accountId: accountId.toString(),
    })
    return (
      <MenuLinkWrapper
        to={retailerProfileLink}
        id={ProfileDropdownIds.ProfileOptionsManage}
        data-testid={ProfileDropdownIds.ProfileOptionsManage}
      >
        {messages.manageProfile}
      </MenuLinkWrapper>
    )
  }
  const brandProfilePath = generatePath(STOREFRONT, {
    accountId: accountId.toString(),
    pageName: '',
  })

  return (
    <NavbarProfileDropdownContainer>
      <NavbarDropdown
        trigger={
          <Trigger
            label={messages.profile}
            id={ProfileDropdownIds.ProfileTrigger}
          />
        }
      >
        <DropdownMenuGroup>
          <DropdownMenuTextLink
            to={brandProfilePath}
            message={messages.manageProfile}
            id={ProfileDropdownIds.ProfileOptionsManage}
            testId={ProfileDropdownIds.ProfileOptionsManage}
          />
          {!isLiteBrandAccount && (
            <DropdownMenuTextLink
              to={DISCOVERY_DASHBOARD}
              message={messages.profileViews}
              id={ProfileDropdownIds.ProfileOptionsViews}
              testId={ProfileDropdownIds.ProfileOptionsViews}
            />
          )}
          <DropdownMenuTextLink
            to={LOOKBOOKS}
            message={messages.lookbooks}
            id={ProfileDropdownIds.ProfileOptionsLookbooks}
            testId={ProfileDropdownIds.ProfileOptionsLookbooks}
          />
          <DropdownMenuTextLink
            to={PRESS}
            message={messages.press}
            id={ProfileDropdownIds.ProfileOptionsPress}
            testId={ProfileDropdownIds.ProfileOptionsPress}
          />
          {!isLiteBrandAccount && (
            <DropdownMenuTextLink
              to={PHOTO_GALLERY}
              message={messages.photoGallery}
              id={ProfileDropdownIds.ProfileOptionsPhotoGallery}
              testId={ProfileDropdownIds.ProfileOptionsPhotoGallery}
            />
          )}
        </DropdownMenuGroup>
      </NavbarDropdown>
    </NavbarProfileDropdownContainer>
  )
}

export default NavbarProfileDropdown
